import { BUSINESS_PROFILE } from '@hive/status'

import React, { useState } from 'react'

import { useFetchAllBusinessProfiles } from '@@partner:graphql/query/businessProfiles/allBusinessProfiles.gql'

import AppLoader from '@components/common/AppLoader'
import GraphQLCommonErrorDisplay from '@components/common/GraphQLCommonErrorDisplay'

import BusinessProfileForm from './BusinessProfileForm'
import ModerationCompleteInfo from './ModerationCompleteInfo'

import { SORT_ORDER_ASC } from '@@partner:config/graphql'


type BusinessProfileModerationState = {
  current_id: number
  decisions: number[]
  showHistory: boolean
}

const DEFAULT_PRODUCT_REVIEW_MODERATION_STATE: BusinessProfileModerationState =
  {
    current_id: 0,
    decisions: [],
    showHistory: false
  }


export default function WaitingCheckBusinessProfilesForm ({
  brandSlug
}: { brandSlug: string }) {
  const [ state, setState ] = useState<BusinessProfileModerationState>(
    DEFAULT_PRODUCT_REVIEW_MODERATION_STATE
  )

  const { data, loading, error } = useFetchAllBusinessProfiles({
    filter: {
      and: [
        {
          fields: [ 'status' ],
          op: 'eq',
          value: [ BUSINESS_PROFILE.PENDING ]
        },
        {
          fields: [ 'id' ],
          op: 'gt',
          value: [ state.current_id ]
        }
      ]
    },
    sort: {
      fieldName: 'id',
      direction: SORT_ORDER_ASC
    },
    pager: {
      limit: 1
    }
  })


  const desicionsFilter = {
    fields: [ 'id' ],
    op: 'contains',
    value: state.decisions
  }


  const currentBusinessProfile = data?.allBusinessProfiles?.edges?.[0]

  const handleNextReview = () => {
    setState((state) => ({
      ...state,
      current_id: Number(currentBusinessProfile?.id),
      decisions: [ ...state.decisions, Number(currentBusinessProfile?.id) ]
    }))
  }
  
  const handleShowHistory = () => {
    setState((state) => ({
      ...state,
      showHistory: !state.showHistory
    }))
  }

  if (!currentBusinessProfile) {
    if (loading) {
      return <AppLoader.Inner content="Загрузка..." />
    }
    return (
      <ModerationCompleteInfo 
        brandSlug={brandSlug} filter={desicionsFilter} />
    )
  }

  if (error) {
    return (
      <GraphQLCommonErrorDisplay
        title={`Не удалось загрузить компанию ${currentBusinessProfile?.name} для модерирования`}
        error={error}
      />
    )
  }

  return (
    <BusinessProfileForm 
      profileId={currentBusinessProfile.id}
      onSaved={handleNextReview}
    />
  )
}